import { useTranslation } from 'react-i18next';
import { Search, BarChart3, PhoneCall, Shield, Clock, Zap } from 'lucide-react';

const benefits = [
  { id: 'google_audit', Icon: Search },
  { id: 'competitor', Icon: BarChart3 },
  { id: 'strategy_call', Icon: PhoneCall },
  { id: 'no_obligation', Icon: Shield },
  { id: 'quick_turnaround', Icon: Clock },
  { id: 'actionable', Icon: Zap },
];

const FreeAnalysisBenefits = () => {
  const { t } = useTranslation();

  return (
    <div className="sticky top-28">
      <h3 className="text-xl font-bold text-gray-900 mb-6">
        {t('free_analysis_page.benefits_title')}
      </h3>
      <div className="space-y-4">
        {benefits.map(({ id, Icon }) => (
          <div
            key={id}
            className="flex items-start gap-4 p-4 rounded-xl bg-gray-50 border border-gray-100 hover:border-emerald-200 hover:bg-emerald-50/50 transition-all group"
          >
            <div className="w-10 h-10 rounded-lg bg-emerald-100 flex items-center justify-center flex-shrink-0 group-hover:bg-emerald-200 transition-colors">
              <Icon className="w-5 h-5 text-emerald-600" />
            </div>
            <div>
              <h4 className="font-semibold text-gray-900 text-sm">
                {t(`free_analysis_page.benefits.${id}.title`)}
              </h4>
              <p className="text-gray-500 text-sm mt-0.5">
                {t(`free_analysis_page.benefits.${id}.description`)}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FreeAnalysisBenefits;
